import { render, staticRenderFns } from "./alkz.vue?vue&type=template&id=329aea95&scoped=true"
import script from "./alkz.vue?vue&type=script&lang=js"
export * from "./alkz.vue?vue&type=script&lang=js"
import style0 from "./alkz.vue?vue&type=style&index=0&id=329aea95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329aea95",
  null
  
)

export default component.exports